// CourtTypeView.js
import React from "react";
import DynamicCard from "./DynamicComponent";
import AccountTypesTable from "../Tables/AllAccountTypes/Index";
import AccountCategoriesTable from "../Tables/AccountCategories";
import AccountSubcategoriesTable from "../Tables/AcocuntSubcategories";
import DebtorsListTable from "../Tables/Debtors";
import AccountsTable from "../Tables/Accounts";
import BanksAccountTable from "../Tables/BankAccounts";
import BanksBranchTable from "../Tables/BankBranch";
import BanksTable from "../Tables/Banks";
import FiscalYearTable from "../Tables/FiscalYears";
import PaymentTypesTable from "../Tables/PaymentTypes";
import SuppliersTable from "../Tables/Suppliers";
import TaxAuthorityTable from "../Tables/TaxAuthorities";
import TaxRateTable from "../Tables/TaxRates";
import CompanyTable from "../../CompanyManagement/Company";
import RegionTable from "../../CompanyManagement/Regions";
import BranchTable from "../../CompanyManagement/Branch";
import DepartmetsTable from "../../CompanyManagement/Departments";
import AddOnsTable from "../../CompanyManagement/Add-Ons";
import CompanyAddOnTable from "../../CompanyManagement/CompanyAdd-ons";
import StorageUnitsTable from "../../CompanyManagement/StoreageUnits";
import SubscriptionPlansTable from "../../CompanyManagement/SubscriptionPlans";
import SmsSettings from "../../CompanyManagement/SmsSettings";
import CompanyEmailSettingsTable from "../../CompanyManagement/CompanyEmailSettings";
import EmailSettingsForm from "../../CompanyManagement/CompanyEmailSettings/EditableForm";
import AdhocSms from "../../adhoc/adhocsms";
import AdhocEmails from "../../adhoc/adhocemail";
import LeadSources from "../../Setup Management/LeadSetups/LeadSources";
import LeadStatuses from "../../Setup Management/LeadSetups/LeadStatus";
import Courts from "../../Setup Management/SystemSetups/Courts";
import Designations from "../../Setup Management/OtherSetups/Designation";
import Departments from "../../Setup Management/OtherSetups/Department";
import DocumentTypes from "../../Setup Management/OtherSetups/Document/Index";
import Events from "../../Setup Management/OtherSetups/EventType";
import FactCategories from "../../Setup Management/OtherSetups/FactCategory";
import PartyTypes from "../../Setup Management/OtherSetups/PartyType";
import Counties from "../../Setup Management/GeographySetups/County";
import Country from "../../Setup Management/GeographySetups/Country";
import UploadLogoTable from "../../CompanyManagement/UploadLogo/index";
import CourtType from "../../Setup Management/SystemSetups/CourtTypes";
import CourtEventType from "../../Setup Management/SystemSetups/CourtEventTypes";
import Gender from "../../Setup Management/SystemSetups/Gender";
import IdentificationTypes from "../../Setup Management/SystemSetups/Indentification";
import Judges from "../../Setup Management/SystemSetups/Judges";
import PhoneCodes from "../../Setup Management/SystemSetups/PhoneCode";
import Title from "../../Setup Management/SystemSetups/Title";
import LeavePolicyTable from "../../HRManagemenet/setups/leavePolicy";
import DocumentApproversTable from "../../HRManagemenet/setups/DocumentApprovers";  
import NSSFContributionMethodsTable from "../../HRManagemenet/setups/NSSFContributionMethods";
import RelationshipTypeTable from "../../HRManagemenet/setups/RelationshipTypes";
import PensionRatesTable from "../../HRManagemenet/setups/PensionRates";
import LeaveApproversTable from "../../HRManagemenet/setups/Approvers";
import CalendarSetupTable from "../../HRManagemenet/setups/CompanyCalendarSetups";
import ImprestApproversTable from "../../HRManagemenet/setups/ImprestApprovers";
import UserFinanceDetailsForm from "../../HRManagemenet/setups/FinancialDetails";
import MpesaCredentialsForm from "../../CompanyManagement/MpesaSettings";
import EmploymentPaymentTypes from "../../Setup Management/MessageTemplates/EmploymentPaymentTypes";
import EmailTemplates from "../../Setup Management/MessageTemplates/EmailTemplates";
import SMSTemplates from "../../Setup Management/MessageTemplates/SmsTemplate";
import AppNotifTemplates from "../../Setup Management/MessageTemplates/AppNotifTemplate";
import PCApplicationsTable from "../../HRManagemenet/PettyCash/PCApplications";
import PCApplicationsByUserTable from "../../HRManagemenet/PettyCash/PCApplicationsByUser";
import PracticeGroupTable from "../../HRManagemenet/setups/PracticeGroup";
import LevelTable from "../../HRManagemenet/setups/Level/LevelTable";
import CurrencyTable from "../Tables/currency";
import DocumnetsApproversTable from "../Tables/ApprovalSetUp";

export const CurrencyView = () => {
  return (
    <DynamicCard>
      <CurrencyTable />
    </DynamicCard>
  );
};
export const PracticeGroup = () => {
  return (
    <DynamicCard>
      <PracticeGroupTable />
    </DynamicCard>
  );
};
export const Level = () => {
  return (
    <DynamicCard>
      <LevelTable />
    </DynamicCard>
  );
};

export const AccountTypesView = () => {
  return (
    <DynamicCard>
      <AccountTypesTable />
    </DynamicCard>
  );
};

export const AccountCategoryView = () => {
  return (
    <DynamicCard>
      <AccountCategoriesTable />
    </DynamicCard>
  );
};
export const AccountSubcategoryView = () => {
  return (
    <DynamicCard>
      <AccountSubcategoriesTable />
    </DynamicCard>
  );
};
export const DebtorsListView = () => {
  return (
    <DynamicCard>
      <DebtorsListTable/>
    </DynamicCard>
  )
}
export const AccountsView = () => {
  return (
    <DynamicCard>
      <AccountsTable />
    </DynamicCard>
  );
};

export const BankAccountsView = () => {
  return (
    <DynamicCard>
      <BanksAccountTable />
    </DynamicCard>
  );
};
export const AccountBankBranchesView = () => {
  return (
    <DynamicCard>
      <BanksBranchTable />
    </DynamicCard>
  );
};
export const BanksView = () => {
  return (
    <DynamicCard>
      <BanksTable />
    </DynamicCard>
  );
};
export const FiscalYearsView = () => {
  return (
    <DynamicCard>
      <FiscalYearTable />
    </DynamicCard>
  );
};
export const PaymentTypesView = () => {
  return (
    <DynamicCard>
      <PaymentTypesTable />
    </DynamicCard>
  );
};
export const Suppliers = () => {
  return (
    <DynamicCard>
      <SuppliersTable />
    </DynamicCard>
  );
};
export const TaxAuthoritiess = () => {
  return (
    <DynamicCard>
      <TaxAuthorityTable />
    </DynamicCard>
  );
};
export const TaxRatesView = () => {
  return (
    <DynamicCard>
      <TaxRateTable />
    </DynamicCard>
  );
};
export const Companies = () => {
  return (
    <DynamicCard>
      <CompanyTable />
    </DynamicCard>
  );
};

export const RegionsView = () => {
  return (
    <DynamicCard>
      <RegionTable />
    </DynamicCard>
  );
};

export const CompanyBranchesView = () => {
  return (
    <DynamicCard>
      <BranchTable />
    </DynamicCard>
  );
};

export const DepartmentView = () => {
  return (
    <DynamicCard>
      <DepartmetsTable />
    </DynamicCard>
  );
};

export const AddOnView = () => {
  return (
    <DynamicCard>
      <AddOnsTable />
    </DynamicCard>
  );
};

// export const CompanyAddOnsView = () => {
//   return (
//     <DynamicCard>
//       <CompanyAddOnTable />
//     </DynamicCard>
//   );
// };

export const SubscriptionPlansView = () => {
  return (
    <DynamicCard>
      <SubscriptionPlansTable />
      {/* <SubscriptionPlansTable /> */}
    </DynamicCard>
  );
};

export const StorageUnitsView = () => {
  return (
    <DynamicCard>
      <StorageUnitsTable />
    </DynamicCard>
  );
};
export const SmsSettingsView = () => {
  return (
    <DynamicCard>
      <SmsSettings />
    </DynamicCard>
  );
};
export const MpesaCredentialsSettings = () => {
  return (
    <DynamicCard>
      <MpesaCredentialsForm />
    </DynamicCard>
  );
};
export const EmailSettingsView = () => {
  return (
    <DynamicCard>
      {/* // <CompanyEmailSettingsTable /> */}
      <EmailSettingsForm />
    </DynamicCard>
  );
};
export const AdhocSmsView = () => {
  return (
    <DynamicCard>
      <AdhocSms />
    </DynamicCard>
  );
};
export const AdhocEmailsView = () => {
  return (
    <DynamicCard>
      <AdhocEmails />
    </DynamicCard>
  );
};
export const LeadSourcesView = () => {
  return (
    <DynamicCard>
      <LeadSources />
    </DynamicCard>
  );
};
export const LeadStatusView = () => {
  return (
    <DynamicCard>
      <LeadStatuses />
    </DynamicCard>
  );
};
export const EmploymentPaymentView = () => {
  return (
    <DynamicCard>
      <EmploymentPaymentTypes />
    </DynamicCard>
  );
};
export const CourtsView = () => {
  return (
    <DynamicCard>
      <Courts />
    </DynamicCard>
  );
};

export const CourtTypeView = () => {
  return (
    <DynamicCard>
      <CourtType />
    </DynamicCard>
  );
};

export const CourtEventTypes = () => {
  return (
    <DynamicCard>
      <CourtEventType />
    </DynamicCard>
  );
};


export const GenderView = () => {
  return (
    <DynamicCard>
      <Gender />
    </DynamicCard>
  );
};

export const IdentificationTypesView = () => {
  return (
    <DynamicCard>
      <IdentificationTypes />
    </DynamicCard>
  );
};

export const JudgesView = () => {
  return (
    <DynamicCard>
      <Judges />
    </DynamicCard>
  );
};

export const PhoneCodesView = () => {
  return (
    <DynamicCard>
      <PhoneCodes />
    </DynamicCard>
  );
};

export const TitleView = () => {
  return (
    <DynamicCard>
      <Title />
    </DynamicCard>
  );
};

export const DepartmentViewView = () => {
  return (
    <DynamicCard>
      <Departments />
    </DynamicCard>
  );
};

export const DesignationView = () => {
  return (
    <DynamicCard>
      <Designations />
    </DynamicCard>
  );
};

export const DocumentView = () => {
  return (
    <DynamicCard>
      <DocumentTypes />
    </DynamicCard>
  );
};

export const EventView = () => {
  return (
    <DynamicCard>
      <Events />
    </DynamicCard>
  );
};

export const FactCategoryView = () => {
  return (
    <DynamicCard>
      <FactCategories />
    </DynamicCard>
  );
};

export const PartyTypesView = () => {
  return (
    <DynamicCard>
      <PartyTypes />
    </DynamicCard>
  );
};

export const CountryView = () => {
  return (
    <DynamicCard>
      <Country />
    </DynamicCard>
  );
};
export const CountyView = () => {
  return (
    <DynamicCard>
      <Counties />
    </DynamicCard>
  );
};
export const UploadLogoView = () => {
  return (
    <DynamicCard>
      <UploadLogoTable />
    </DynamicCard>
  );
};
//HR Management
export const LeavePolicyView = () => {
  return (
    <DynamicCard>
      <LeavePolicyTable />
    </DynamicCard>
  );
};
export const DocumentsApproversView = () => {
  return (
    <DynamicCard>
      <DocumentApproversTable/>
    </DynamicCard>
  );
};

export const LeaveApprovers = () => {
  return (
    <DynamicCard>
      <LeaveApproversTable />
    </DynamicCard>
  );
};
export const NSSFContributionMethods = () => {
  return (
    <DynamicCard>
      <NSSFContributionMethodsTable />
    </DynamicCard>
  );
};
export const RelationshipTypes = () => {
  return (
    <DynamicCard>
      <RelationshipTypeTable />
    </DynamicCard>
  );
};
export const PensionRates = () => {
  return (
    <DynamicCard>
      <PensionRatesTable />
    </DynamicCard>
  );
};
export const CompanyCalendarSetups = () => {
  return (
    <DynamicCard>
      <CalendarSetupTable />
    </DynamicCard>
  );
};
export const RequisitionApprovers = () => {
  return (
    <DynamicCard>
      <ImprestApproversTable />
    </DynamicCard>
  );
};
export const FinanceDetails = () => {
  return (
    <DynamicCard>
      <UserFinanceDetailsForm />
    </DynamicCard>
  );
};
export const AllPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsTable />
    </DynamicCard>
  );
};

export const MyPettyCashApplications = () => {
  return (
    <DynamicCard>
      <PCApplicationsByUserTable />
    </DynamicCard>
  );
};

export const EmailTemplate = () => {
  return (
    <DynamicCard>
      <EmailTemplates />
    </DynamicCard>
  );
};
export const SMSTemplate = () => {
  return (
    <DynamicCard>
      <SMSTemplates />
    </DynamicCard>
  );
};

export const AppNotification = () => {
  return (
    <DynamicCard>
      <AppNotifTemplates />
    </DynamicCard>
  );
};

export const DocumentsApprovers = () => {
  return (
    <DynamicCard>
      <DocumnetsApproversTable />
    </DynamicCard>
  );
};
